import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
@Component({
    selector: 'ebb-portal-dialog-paform-warn',
    templateUrl: './dialog-paform-warn.component.html',
    standalone: false
})
export class DialogPafWarnComponent implements OnInit {
  constructor(
    public readonly dialogRef: MatDialogRef<DialogPafWarnComponent>,
  ) { }

  ngOnInit() {
  }

  public onClickOk(): void {
    this.dialogRef.close();
  }

}
